import {Component, OnInit, OnDestroy, Input} from '@angular/core';

@Component({
    selector: 'app-cgu-content',
    templateUrl: './cgu-content.component.html',
    styleUrls: ['./cgu-content.component.scss'],
    standalone: false
})
export class CguContentComponent implements OnInit, OnDestroy {

    @Input()
    fullSize: boolean = false;

    constructor() { }

    ngOnInit(): void {
        const element = document.querySelector('app-cgu-content')
        element.addEventListener('click', this.onClick);
    }

    ngOnDestroy(): void {
        const element = document.querySelector('app-cgu-content')
        element.removeEventListener('click', this.onClick);
    }

    onClick(event: Event): void {
        const target = event.target as HTMLElement;
        const anchor = target.closest('a');
console.log("anchor", anchor);
        if (anchor instanceof HTMLAnchorElement && anchor.hash.length > 0) {
            const targetName = anchor.hash.substring(1);
            const targetElement = document.querySelector(`[name="${targetName}"], #${targetName}`);

            if (targetElement) {
                event.preventDefault();
                targetElement.scrollIntoView({ block: 'start', behavior: 'smooth', inline: 'nearest' });
            }
        }
    }

}
